import React, { useEffect, useState } from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import { Grid } from '@mui/material';
import SoftBox from 'components/SoftBox';
import { baseURL } from 'utils/api';
import SoftButton from 'components/SoftButton';
import AddressForm from "../businessDetail/components/Address/form/index";
import NotFound from 'components/notFound';
import Loading from 'components/ApnaLoading';

const index = () => {

  const [data, setData] = useState([]);
  const id = localStorage.getItem("id");
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        fetch(`${baseURL}/profile/getBranches?userId=${id}`)
          .then((res) => res.json())
          .then((res) => {
            if (res.status) {
              const findDefault = res?.profile.find((item) => item.isDefault === true);
              localStorage.setItem("defaultProfile", findDefault?.profileImage||null);
              setLoading(false)
              setData(res?.profile);
            }
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [refresh]);


  const handelRefresh     = () => { 
    setRefresh(refresh + 1);
  } 




  const findMainBusiness = data.find((item) => item.child === false);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "10px",
        }}
      >
        <SoftButton
          onClick={() => setShow(!show)}
          variant="gradient"
          color="info"
          size="large"
        >
          Add Location
        </SoftButton>
      </SoftBox>
      <AddressForm setRefresh={setRefresh} mainBusiness={findMainBusiness} show={show} unShow={setShow} />
      <SoftBox p={2}>
        <Grid container spacing={3}>

          {loading ?<Loading/> :  
            data && data?.length > 0 ? data.map((item) => (
              <Grid item xs={12} md={6} xl={3}>
                <DefaultProjectCard
                  image={item?.profileImage}
                  label={item?.addLine?.length>50?item?.addLine.slice(0,50)+'...':item?.addLine}
                  title={item?.firstName}
                  setRefresh={handelRefresh}
                  businessId={item?._id}  
                  primary={item?.isDefault}
                  // primary={item?.child}
                  action={{
                    type: "internal",
                    route: `/business/detail/${item?._id}`,
                    color: "info",
                    label: "view ",
                  }}
                />
              </Grid>
            )) : <NotFound />
          }

        </Grid>
      </SoftBox>
    </DashboardLayout>
  )
}

export default index








